import {
  Box,
  Button,
  Container,
  Modal,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { BG_COLORS } from "../../constants";
import { useAppSelector } from "../../store/hooks";
import { PricingPlans } from "../Subscriptions/partials/PricingPlans";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useAnalytics } from "../../hooks/useAnalytics";
import { selectUserProfile } from "../../features/user/user.selector";
import { CurrentPlan } from "../Billing/partials/CurrentPlan";

const ChoosePlan: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const zIndex = Math.max(...Object.values(theme.zIndex)) + 2;
  const { data: pricingPlans } = useAppSelector((state) => state.pricingPlans);
  const { trackViewPricing } = useAnalytics();
  const currentPlan = useAppSelector((state) => state.user.user?.planDetails);

  const registeredFrom = searchParams.get("registeredFrom");
  const redirectUrl = registeredFrom
    ? `/product-analyzer/payment-success?fromSignup=true&registeredFrom=${registeredFrom}`
    : "/product-analyzer/payment-success";

  // const plans = pricingPlans.map((plan) =>
  //   plan.name.toLowerCase() === "free"
  //     ? {
  //         ...plan,
  //         onChange: () => {
  //           navigate("/product-analyzer");
  //         },
  //       }
  //     : plan,
  // );

  useEffect(() => {
    trackViewPricing(pricingPlans);
  }, [trackViewPricing, pricingPlans]);

  return (
    <Modal
      open
      sx={{ zIndex, overflow: "auto" }}
      tabIndex={-1}
      disableAutoFocus
    >
      <Box width="100%" minHeight="100dvh" bgcolor={BG_COLORS.default}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Stack alignItems="center" mb={{ xs: 4, md: 8 }} spacing={1}>
            <Typography
              textAlign="center"
              fontSize={{ xs: 24, md: 28 }}
              fontWeight={600}
            >
              Set Up Your Pricing Plan
            </Typography>
            {/* <Button onClick={() => navigate("/product-analyzer")}>
              Skip this time
            </Button> */}
          </Stack>
          <PricingPlans
            plans={pricingPlans}
            currentPlanId={currentPlan?.planId}
            redirectUrl={redirectUrl}
          />
        </Container>
      </Box>
    </Modal>
  );
};

export default ChoosePlan;
